export const PROFILE_ONE_LINER_LIMIT = 160;
export const PROFILE_BIO_LIMIT = 500;

export const BANK_ACCOUNT_TYPE_OPTIONS = [
  { value: '1', label: '普通預金' },
  { value: '2', label: '当座預金' },
  { value: '3', label: '貯蓄預金' },
];

export const EMPTY_PROFILE_FORM = {
  profile_one_liner: '',
  bio: '',
  bio_small_group: '',
  bio_large_group: '',
};

export const EMPTY_BANK_FORM = {
  bank_name: '',
  bank_code: '',
  branch_name: '',
  branch_code: '',
  account_type: '',
  account_number: '',
  account_name: '',
  invoice_registered: false,
  invoice_company: '',
  invoice_number: '',
  invoice_sender_mode: 'profile',
  invoice_sender_name: '',
  invoice_sender_company_name: '',
  invoice_sender_hide_company_name: false,
  invoice_sender_email: '',
  invoice_sender_phone: '',
};

export const STEP_META = {
  profile_photo: {
    shortTitle: '写真確認',
    title: 'プロフィール写真の確認',
    description:
      'Casticart内やタクティカートイベント情報公開ページで参加者情報として利用される写真です。',
    icon: '●',
  },
  profile_basic: {
    shortTitle: '基本情報',
    title: '基本プロフィール',
    description: 'Casticart内のひとことと、掲載用の紹介プロフィールを整えます。',
    icon: 'i',
  },
  bank_info: {
    shortTitle: '振込先口座',
    title: '振込先口座',
    description: '報酬支払いに必要な口座情報を登録します。',
    icon: '￥',
  },
  promo_photo: {
    shortTitle: '宣材写真',
    title: '宣材写真',
    description: 'イベント紹介などで利用できる写真を登録します。',
    icon: '□',
  },
};

const toIntOrNull = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
};

export const appendVariant = (url, variant) => {
  if (!url || !variant) return url || '';
  return url.includes('?') ? `${url}&variant=${variant}` : `${url}?variant=${variant}`;
};

export const normalizeProfilePayload = (profile, profileForm) => ({
  ...profile,
  profile_one_liner: String(profileForm.profile_one_liner || '').slice(0, PROFILE_ONE_LINER_LIMIT),
  bio: String(profileForm.bio || '').slice(0, PROFILE_BIO_LIMIT),
  bio_small_group: String(profileForm.bio_small_group || '').slice(0, 300),
  bio_large_group: String(profileForm.bio_large_group || '').slice(0, 120),
  parts: Array.isArray(profile?.parts) ? profile.parts : [],
  group_tags: Array.isArray(profile?.group_tags) ? profile.group_tags : [],
  main_activity_regions: Array.isArray(profile?.main_activity_regions)
    ? profile.main_activity_regions
    : [],
  sub_activity_regions: Array.isArray(profile?.sub_activity_regions)
    ? profile.sub_activity_regions
    : [],
  birth_year: profile?.birth_year_hidden === true ? null : toIntOrNull(profile?.birth_year),
  birth_year_hidden: Boolean(profile?.birth_year_hidden),
  birth_month: toIntOrNull(profile?.birth_month),
  birth_day: toIntOrNull(profile?.birth_day),
  allow_day_trip: Boolean(profile?.allow_day_trip),
  allow_overnight: Boolean(profile?.allow_overnight),
});

export const displayNameForProfile = (profile) =>
  profile?.display_name ||
  profile?.artist_name ||
  profile?.stage_name ||
  profile?.name ||
  profile?.full_name ||
  'アーティスト';

export const stepMeta = (step) => ({
  ...step,
  ...(STEP_META[step?.key] || {}),
});
